/* eslint-disable ember/no-computed-properties-in-native-classes */
import { reads } from '@ember/object/computed';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type StoreService from '@ember-data/store';
import Component from '@glimmer/component';
import type CompanyModel from 'garaje/models/company';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type FlowService from 'garaje/services/flow';
import type IsOpenService from 'garaje/services/is-open';
import type StateService from 'garaje/services/state';
import type VisitorsOnboardingService from 'garaje/services/visitors-onboarding';
import { DEFAULT_FLOW_NAME } from 'garaje/utils/enums';

interface SideBarLocationMenuComponentSignature {
  Args: {
    company: CompanyModel;
    trackClickEvent: unknown;
  };
}

export default class SideBarLocationMenuComponent extends Component<SideBarLocationMenuComponentSignature> {
  @service declare isOpen: IsOpenService;
  @service declare state: StateService;
  @service declare store: StoreService;
  @service('flow') declare employeeScreeningFlow: FlowService;
  @service declare visitorsOnboarding: VisitorsOnboardingService;
  @service declare flashMessages: FlashMessagesService;
  @service declare router: RouterService;

  @reads('employeeScreeningFlow.activeEmployeeScreeningFlow')
  activeEmployeeScreeningFlow!: FlowService['activeEmployeeScreeningFlow'];
  @reads('state.currentLocation') currentLocation!: StateService['currentLocation'];
  @reads('state.vrSubscription') vrSubscription!: StateService['vrSubscription'];
  @reads('state.workplaceSubscription') workplaceSubscription!: StateService['workplaceSubscription'];
  @reads('state.currentCompany') currentCompany!: StateService['currentCompany'];

  employeeRegistrationFilter = DEFAULT_FLOW_NAME.EMPLOYEE_SCREENING;

  get shouldHideNavItems(): boolean {
    return !this.state.hasAnyFeatures;
  }
}
